import React, {useState} from "react";
import classNames from "classnames/bind";

import { ScreenInfo } from "../../components/ScreenInfo";
import { Button } from "../../components/Button";
import { WelcomeCarousel } from "../../components/WelcomeCarousel";

import { useStateManager } from "utils/useStateManager";
import { DietanamnezType } from "types/DietanamnezType";

import styles from "./WelcomeBack.module.css";
import {CancelModal} from "../../components/CancelModal";

const cx = classNames.bind(styles);

type Props = {
  onSubmit: () => void;
};

const duration = {
  [DietanamnezType.LONG]: 100,
  [DietanamnezType.SHORT]: 36,
};

export const WelcomeBack: React.FC<Props> = (props) => {
  const { linkInfo, userType, step, dietanamnez, tokenRegistration } = useStateManager();
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <ScreenInfo
      title={
        linkInfo?.userName ? (
          <>
            С возвращением, <br /> {linkInfo?.userName}!
          </>
        ) : (
          "С возвращением!"
        )
      }
    >
      <p className={cx("info")}>
        Вы остановились <br />
        на {step + 1} вопросе из {duration[dietanamnez?.custom_тип_да!]}. Мы
        быстро
        <br />
        закончим, продолжим?
      </p>

      <WelcomeCarousel
        userType={userType}
        dietanamnezType={dietanamnez?.custom_тип_да!}
        carouselType="BACK"
      />

      <div className={cx("actions")}>
        {linkInfo?.custom?.custom_возможность_принудительного_завершения_опроса_саморегистрации && tokenRegistration &&
          <Button
            color="white"
            block
            size="medium"
            rounded
            type="button"
            onClick={() => setIsModalVisible(true)}
          >
            Прервать
          </Button>
        }
        <Button
          color="white"
          block
          size="medium"
          rounded
          type="button"
          onClick={() => props.onSubmit()}
        >
          Продолжить
        </Button>
      </div>
      {isModalVisible &&
        <CancelModal
          isOpen={isModalVisible}
          handleClose={() => setIsModalVisible(false)}
        />}
    </ScreenInfo>
  );
};
